<template>
  <div>
    <nav-header ref="navHeader"
                v-bind:showSearch="p_showSearch"
                v-bind:loginModalFlag="p_loginModalFlag"
                v-on:showLoginModal="p_showLoginModal"
                v-on:closeLoginModal="p_closeLoginModal"
    ></nav-header>
    <nav-bread>
      <span style="margin-right:10px;" slot="mine">个人中心</span>
      <!--<span style="margin-right:10px;" slot="orderList">我的订单</span>-->
    </nav-bread>
    <div class="container">
      <el-container>
        <nav-left v-bind:activeIndex="p_activeIndex"></nav-left>
        <el-container style="margin:40px 0 0 20px;">
          <el-header>我的退换</el-header>
          <el-main>
            我的退换

          </el-main>
        </el-container>
      </el-container>
    </div>
  </div>


</template>

<script>
  import '@/assets/css/index.css'
  import NavLeft from '@/components/NavLeft.vue'
  import NavHeader from '@/components/Header'
  import NavBread from '@/components/Bread.vue'

  export default {
    name: "my-refund",
    data(){
      return {
        p_activeIndex:"4",
        p_showSearch:true,
        p_loginModalFlag:false
      }
    },
    components:{
      NavLeft,
      NavHeader,
      NavBread
    },
    methods:{
      p_showLoginModal(){
        this.p_loginModalFlag = true
      },

      p_closeLoginModal(){
        this.p_loginModalFlag = false
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/user/MyRefund.vue